import React from "react";

const FunnelTable = ({ data = [] }) => {
  if (!data.length) return null;

  const signupCount = data[0]?.users || 0;

  return (
    <div className="table-responsive">
      <table className="table table-bordered mt-3">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Step</th>
            <th>Users</th>
            <th>Step Conversion %</th>
            <th>Of Members Here Today %</th>
            <th>Dropped From Previous</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            // A row with a `basis` is not a subset of the row above it (today
            // that is Purchase, counted against every member rather than only
            // those who reached chat). Its conversion is stated against that
            // basis, and "dropped from previous" has no meaning for it.
            const unchained = !!row.basis;
            const prev = index > 0 && !unchained ? data[index - 1].users : null;
            const droppedCount = prev !== null ? prev - row.users : null;
            const overall = signupCount
              ? ((row.users / signupCount) * 100).toFixed(2)
              : 0;
            return (
              <tr key={row.step}>
                <td>{index + 1}</td>
                <td>{row.label || row.step?.replace(/_/g, " ")}</td>
                <td>{row.users}</td>
                <td>
                  {row.conversion}%
                  {unchained && (
                    <span className="text-muted text-sm"> of {row.basisLabel || "members here today"}</span>
                  )}
                </td>
                <td>{overall}%</td>
                <td>
                  {droppedCount === null
                    ? "-"
                    : droppedCount > 0
                    ? `${droppedCount} users`
                    : "None"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FunnelTable;
